export default __webpack_public_path__ + "static/cp-red-efc9c4f8b89311ea0fbba9343cba4e95.png";